module.exports = __webpack_public_path__ + "static/assets/e914d67e61cb4a222a199137642ecb77.png";